

export const MAX_DIE_SIDES: number = 20;
export const MAX_DIE_AMOUNT: number = 8;

// The zeroeth array are possible results, the first array are frequencies.
type DiceRollResultDistribution = number[][];

function applyModifier(distribution: DiceRollResultDistribution, modifier: number): DiceRollResultDistribution {
    return [
        Array.from(
            distribution[0].map((result) => result + modifier)),
        distribution[1]
    ]
}

export class DiceRollResults {
    // Indexed by [dieAmount][dieSides], so result of 2d6 will be result[2][6]
    results: DiceRollResultDistribution[][];

    private constructor() {
        // Intentionally left empty, because initailzation is expensive and we don't want it to seem cheap.
    }

    public static precalculated(dieAmount: number, dieMaxSides: number) {
        throw Error("Unimplemented");
    }

    public static calculateDistributionForRoll(roll: DiceRoll): DiceRollResultDistribution {
        throw Error("Unimplemented");
    }


    public getResultDistribution(roll: DiceRoll): DiceRollResultDistribution {
        let resultWithoutModifiers: DiceRollResultDistribution | null = null;

        if (roll.amount < this.results.length) {
            const resultsForAmount = this.results[roll.amount];
            if (roll.sides < resultsForAmount.length) {
                resultWithoutModifiers = resultsForAmount[roll.sides];
            }
        }

        if (resultWithoutModifiers === null) {
            resultWithoutModifiers = DiceRollResults.calculateDistributionForRoll(roll);
        }

        return applyModifier(resultWithoutModifiers, roll.modifier);
    }

}

export class DiceRoll {
    readonly amount: number;
    readonly sides: number;
    readonly modifier: number;

    constructor(amount: number, sides: number, modifier: number) {
        this.amount = amount;
        this.sides = sides;
        this.modifier = modifier;
    }

    // Possible values that this roll can produce
    public valueRange(): number[] {
        const min = this.amount + this.modifier;
        const max = (this.amount * this.sides) + this.modifier;
        return Array.from({ length: max - min }, (_, min) => min + 1)
    }

    public max(): number {
        return (this.amount * this.sides) + this.modifier;
    }

    public min(): number {
        return this.amount + this.modifier;
    }

    public average(): number {
        return (this.max() + this.min()) / 2;
    }

    public asText(): string {
        let modifier = "";
        if (this.modifier > 0) {
            modifier = `+${this.modifier}` 
        } else if (this.modifier === 0) {
            modifier = ""
        } else {
            modifier = `${this.modifier}`
        }
        return `${this.amount}d${this.sides}${modifier}`
    }

    // // Out of all possible rolls, which probability they have
    // public distribution(): number[] {
    //     const valueRange = this.valueRange();

    //     const results = []
    //     for (let dieNum = 0; dieNum < this.amount; dieNum++) {
    //         for (let result = 1; result <= this.kind; result++) {

    //         }

    //     }
    //     valueRange.map((value, idx) => {


    //     })
    // }
}
